module.exports = __webpack_public_path__ + "img/68.57b4dbe3.jpg";